import { render, staticRenderFns } from "./proDetails.vue?vue&type=template&id=acd6910c&"
import script from "./proDetails.vue?vue&type=script&lang=js&"
export * from "./proDetails.vue?vue&type=script&lang=js&"
import style0 from "./proDetails.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports